import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { RideChat } from '../components/RideChat';
import { useAuth } from '../contexts/AuthContext';

/**
 * Standalone Ride-Chat page — route: /chat/:rideId
 * Uses the in-ride <RideChat /> component with DeepL toggle.
 */
export default function RideChatPage() {
  const { rideId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div style={pageBg} data-testid="ride-chat-page">
      <button data-testid="ride-chat-back" onClick={() => navigate(-1)} style={backBtn}>
        <ArrowLeft size={16} /> Zurück
      </button>
      <RideChat rideId={rideId} me={user || { id: '', name: '', lang: 'de' }} />
    </div>
  );
}

const pageBg = {
  minHeight: '100vh',
  background: 'linear-gradient(135deg,#0b1220 0%,#0f172a 60%,#020617 100%)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: 20, position: 'relative',
};
const backBtn = {
  position: 'absolute', top: 18, left: 18,
  background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: 8, padding: '6px 12px', color: '#94a3b8',
  display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer',
};
